// extracted by mini-css-extract-plugin
export default {"mui-select":"Participants_mui-select__OtLjD"};